/**
 * Mount-only component that installs the offline exit guard. Keeps
 * `main.tsx` free of top-level hook calls.
 *
 * See `useOfflineExitGuard` for the full behaviour contract.
 */
import { useOfflineExitGuard } from './useOfflineExitGuard';

export function OfflineExitGuard(): null {
  useOfflineExitGuard();
  return null;
}
